import {useLocation, useNavigate, useParams} from "react-router-dom";
import {PageHeader} from "../../../components/PageHeader";
import React, {useEffect, useMemo, useState} from "react";
import ApprovalComponent from "../../settings/approval/new/ApprovalComponent";
import Th_title from "../../../components/Th_title";
import {useDispatch} from "react-redux";
import {getDailyCheckReport, updateDailyCheckReport} from "../../../api/evaluation/DailyCheckReportService";
import {skeleton} from "../../../redux/slice/apiSlice";
import {ContentCategory} from "../../../constant/CodeSpecNum";
import ReadOnlyInputBasic from "../../../components/input/ReadOnlyInputBasic";
import {
    DetailFilePanel,
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
    DetailSummaryListButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";
import {SettingsContentHeroActions} from "../../settings/shared/SettingsContentHeroActions";
import DailyCheckReportItemsPanel from "./DailyCheckReportItemsPanel";

function DailyCheckReportUpdate() {
    const {id} = useParams();
    const [dailyCheckReport, setDailyCheckReport] = useState({});
    const [list, setList] = useState([]);

    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!id) return;

        setDailyCheckReport({});
        setList([]);
        dispatch(skeleton(true));

        getDailyCheckReport(id).then((dailyCheck) => {
            setDailyCheckReport(dailyCheck.data);
            setList(dailyCheck.data.children);
        }).finally(() => dispatch(skeleton(false)));
    }, [id, dispatch]);

    const update = async () => {
        const finalData = {
            ...dailyCheckReport,
            children: list,
        };

        const response = await updateDailyCheckReport(finalData);
        if (response.status === 200) {
            alert("수정되었습니다.");
            navigate(`/evaluation/dailyCheck/${response.data.id}`, {
                state: {test: location.state},
            });
        }
    };

    const handleUpdate = () => {
        if (window.confirm("수정 완료합니다.")) {
            update();
        }
    };

    const canUpdate = dailyCheckReport.auth?.update;

    const headerActions = (
        <SettingsContentHeroActions>
            <DetailSummaryListButton url="/evaluation/dailyCheck">취소</DetailSummaryListButton>
            {canUpdate ? (
                <DetailSummaryButton onClick={handleUpdate}>수정</DetailSummaryButton>
            ) : null}
        </SettingsContentHeroActions>
    );

    function handleInputChange(value, index, target) {
        setList((prevData) =>
            prevData.map((dataItem, dataIndex) => {
                if (dataIndex === index) {
                    return {...dataItem, [target]: value};
                }
                return dataItem;
            })
        );
    }

    const itemsPanelTitle = useMemo(
        () => dailyCheckReport.dailyCheck?.name || "체크항목",
        [dailyCheckReport.dailyCheck?.name],
    );

    if (Object.keys(dailyCheckReport).length === 0) {
        return null;
    }

    return (
        <div className="common-container container-height-full border-l-gray detail-list-layout asset-detail-list-layout flex min-h-0 flex-1 flex-col">
            <PageHeader
                header="일일체크현황"
                indicator="평가관리/보고서 > 업무보고서 > 일일체크현황 > 수정"
                headerActions={headerActions}
            />

            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-auto">
                    <DetailPanel title="점검내용">
                        <DetailKvTable>
                            <tbody>
                            <tr>
                                <Th_title title="등록일" colspan={1} className="fieldset-td">
                                    <ReadOnlyInputBasic target="createdAt" value={dailyCheckReport.createdAt}/>
                                </Th_title>
                                <Th_title title="등록자" colspan={1} className="fieldset-td">
                                    <ReadOnlyInputBasic target="createdBy" value={dailyCheckReport.createdBy?.name}/>
                                </Th_title>
                            </tr>
                            <tr>
                                <Th_title title="수정일" colspan={1} className="fieldset-td">
                                    <ReadOnlyInputBasic target="updatedAt" value={dailyCheckReport.updatedAt}/>
                                </Th_title>
                                <Th_title title="수정자" colspan={1} className="fieldset-td">
                                    <ReadOnlyInputBasic target="updatedBy" value={dailyCheckReport.updatedBy?.name}/>
                                </Th_title>
                            </tr>
                            <tr>
                                <Th_title title="체크일자" colspan={3} className="fieldset-td">
                                    <ReadOnlyInputBasic target="checkDate" value={dailyCheckReport.checkDate}/>
                                </Th_title>
                            </tr>
                            <tr>
                                <Th_title title="일일체크코드" colspan={3} className="fieldset-td">
                                    <ReadOnlyInputBasic target="dailyCheck" value={dailyCheckReport.dailyCheck?.name}/>
                                </Th_title>
                            </tr>
                            </tbody>
                        </DetailKvTable>
                    </DetailPanel>

                    <DailyCheckReportItemsPanel
                        title={itemsPanelTitle}
                        list={list}
                        mode="view"
                        editable={canUpdate}
                        onInputChange={handleInputChange}
                    />

                    <ApprovalComponent
                        auth={canUpdate}
                        contentId={dailyCheckReport.id}
                        contentCategory={ContentCategory.DAILY_CHECK_REPORT}
                    />

                    <DetailFilePanel
                        title="파일"
                        isEditing
                        tableInfo={{tableName: "daily_check_report", joinKey: id}}
                    />
                </div>
            </DetailListPage>
        </div>
    );
}

export {DailyCheckReportUpdate};
